import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/comprehensive-icon1.png'
import _imports_1 from '@/assets/images/comprehensive-icon2.png'
import _imports_2 from '@/assets/images/comprehensive-icon3.png'
import _imports_3 from '@/assets/images/comprehensive-icon4.png'
import _imports_4 from '@/assets/images/comprehensive-icon5.png'
import _imports_5 from '@/assets/images/comprehensive-icon6.png'


const _withScopeId = n => (_pushScopeId("data-v-05d13b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comprehensive-analysis" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_5 = { class: "info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "发明申请量", -1))
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_10 = { class: "info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "发明专利有效量", -1))
const _hoisted_12 = { class: "number" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_15 = { class: "info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "实用新型专利", -1))
const _hoisted_17 = { class: "number" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_20 = { class: "info" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "外观设计专利", -1))
const _hoisted_22 = { class: "number" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_25 = { class: "info" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "PCT申请量", -1))
const _hoisted_27 = { class: "number" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_30 = { class: "info" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "企业数量", -1))
const _hoisted_32 = { class: "number" }

import { storeToRefs } from 'pinia'
  import {useHomeDataStore} from '@/pinia/useHomeDataStore'
  import TitleCpn from '../../../Title/TitleCpn.vue'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ComprehensiveAnalysis',
  setup(__props) {

  const homeDataStore = useHomeDataStore()
  const { data } = storeToRefs(homeDataStore)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "综合数据分析" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(data)?.left1.applicationVolume), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data)?.left1.effectiveDose), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(data)?.left1.newType), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data)?.left1.design), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data)?.left1.PCT), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(data)?.left1.firms), 1)
        ])
      ])
    ])
  ]))
}
}

})